<template>
    <nav id="main-nav" :class="{ open: nav_open }">
        <div class="nav-toggle" @click="toggleNav">
            <span></span>
            <span></span>
        </div>
        <div class="nav-panel">
            <div class="nav-panel-inner">
                <button class="close-nav-panel" @click="toggleNav"></button>
                <button class="close-nav-sub-menu" @click="closeSubMenu" :class="{active: sub_menu_open !== false}"></button>
                <ul class="primary-nav" :class="{sub_menu_open: sub_menu_open !== false}">
                    <li><a href="/dashboard" @click="openSubMenu($event, 1)">Dashboard</a>
                        <ul :class="{active: sub_menu_open === 1}">
                            <li><a href="/player">Today's routine</a></li>
                            <li><a href="/calendar">View my calendar</a></li>
                        </ul>
                    </li>
                    <li><a href="/workout-library" @click="openSubMenu($event, 2)">Workout library<span class="menu-clause" v-if="new_video_count" style="margin-left:2px">(+{{ new_video_count }})</span></a>
                        <ul :class="{active: sub_menu_open === 2}">
                            <li><a href="/workout-library">All the routines<span class="menu-clause" v-if="all_video_count" style="margin-left:2px">({{ all_video_count }})</span></a></li>
                            <li><a href="/monthly-calls-library">Monthly calls<span class="menu-clause" v-if="monthly_calls_count" style="margin-left:2px">({{ monthly_calls_count === 'none' ? '0' : monthly_calls_count }})</span></a></li>
                        </ul>
                    </li>
                    <li id="the-book-menu"><a href="/builder" @click="openSubMenu($event, 3)"><span>The book <span>on video</span></span></a>
                        <ul :class="{active: sub_menu_open === 3}">
                            <li><a href="/chapters">Browse the chapters</a></li>
                            <li><a href="/builder">Customise my book moves</a></li>
                        </ul>
                    </li>
                </ul>
                <ul class="lower-nav" :class="{sub_menu_open: sub_menu_open !== false}">
                    <li><a href="/account/settings">My account</a></li>
                    <li><a :href="this.routes['league-table']">Stretch challenge</a></li>
                    <li><a :href="this.routes['long-term-league']">Long-term league</a></li>
                    <li class="mb100"><a :href="this.routes['stretch-store']">Stretch store</a></li>
                    <li><a href="/info/terms-and-conditions">Terms</a></li>
                    <li><a href="/info/support">Support</a></li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        data(){
    	    return {
    	    	nav_open: false,
                sub_menu_open: false
            }
        },
        props: [
            'routes',
            'new_video_count',
            'all_video_count',
            'monthly_calls_count'
        ],
        mounted() {

        },
        methods: {
            toggleNav: function(){
            	this.nav_open = !this.nav_open;
            	if(!this.nav_open){
            		this.sub_menu_open = false;
                }
            },
            openSubMenu: function(e, target_sub_menu){
            	if(!this.$store.getters.isDesktopScreen){
                    e.preventDefault();
                    // now continue with touch screen functionality
                    this.sub_menu_open = target_sub_menu;
                }
            },
            closeSubMenu: function(e){
            	this.sub_menu_open = false;
            }
        }
    }
</script>
